import { Col, Container, Image, Row } from "react-bootstrap";
import * as yup from "yup";
import { PHONE_REGEX, toWebp } from "../../../utils/common";
import dynamic from "next/dynamic";
import styles from "./style.module.scss";
import { useRef } from "react";

const BannerHireNowForm = dynamic(() =>
	import("../../forms/banner-hire-now-form")
);

const Banner = (props) => {
	const { data } = props;

	const divRef = useRef(null);

	const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
    const imageUrl = toWebp(baseUrl + data?.banner_image?.data?.attributes?.url)
	// useEffect(() => {
	// 	const imageUrl = toWebp(baseUrl + data?.banner_image?.data?.attributes?.url);
	// 	divRef.current.style.backgroundImage = `url(${imageUrl})`;
	// }, [data, baseUrl]);

	const bannerFormSchema = yup
		.object({
			employee_name: yup.string().trim().required("Name is required."),
			employee_email: yup
				.string()
				.email("Email is not valid.")
				.required("Email is required."),
			contact_no: yup
				.string()
				.min(10, "Invalid phone number")
				.max(13, "Invalid phone number")
				.matches(PHONE_REGEX, "Invalid phone number"),
			company_name: yup.string(),
			requirements: yup.string().required("Requirements are required."),
		})
		.required();

	const bannerFormInitialValues = {
		employee_name: "",
		employee_email: "",
		contact_no: "",
		company_name: "",
		requirements: "",
	};

	return (
		<section
			// ref={divRef}
			className={`contact-new-section section-pad-top-banner ${styles["home-banner-section"]}  ${styles["technology-new-section"]}` }
		>
			<div className={styles["banner-background"]}>
               <Image
			   src={imageUrl}
			   alt="Banner Background"
						fill
						priority
						quality={80}
						sizes="100vw"
						loading="eager"
						style={{
							// objectFit: "cover",
							// objectPosition: "center",
							// maxHeight:'800px',
							// maxWidth:'1800px'

						}}
			   />
			</div>
			<Container className={styles["container"]}>
				<Row >
					{/* className={styles["small-reverse-row"]} */}
					<Col lg={6} md={6}>
						<div className={styles["banner-content"]}>
							<h1 className="text-white">{data?.title}</h1>

							<p className="text-white">{data?.description}</p>

							<ul className={styles["banner-tags"]}>
								{data?.services?.map((service, index) => (
									<li key={service.id}>{service.label}</li>
								))}
							</ul>
						</div>
					</Col>
					<Col lg={6} md={6}>
						<div className="contact-right-form bg-white border-2 border-color">
							<h3 className="text-large font-semibold text-black">
								{data?.form_title}
							</h3>
							<BannerHireNowForm
								schema={bannerFormSchema}
								initialValues={bannerFormInitialValues}
								isNew={true}
							/>
							{/* <Row>
								<Col lg={6} md={6}>
								<div className="form-group form-floating normal">
									<Field
									className="form-control"
									name="employee_name"
									placeholder="Full name*"
									/>
									<label htmlFor="employee_name" className="form-label">
									Full name*
									</label>
								</div>
								</Col>
								<Col lg={6} md={6}>
								<div className="form-group form-floating normal">
									<Field
									className="form-control"
									name="employee_name"
									placeholder="Full name*"
									/>
									<label htmlFor="employee_name" className="form-label">
									Email*
									</label>
								</div>
								</Col>
								<Col lg={6} md={6}>
								<div className="form-group form-floating normal">
									<Field
									className="form-control"
									name="employee_name"
									placeholder="Full name*"
									/>
									<label htmlFor="employee_name" className="form-label">
									Phone number*
									</label>
								</div>
								</Col>
								<Col lg={6} md={6}>
								<div className="form-group form-floating normal">
									<Field
									className="form-control"
									name="employee_name"
									placeholder="Full name*"
									/>
									<label htmlFor="employee_name" className="form-label">
									Country*
									</label>
								</div>
								</Col>
								<Col lg={12} md={12}>
								<div className="form-group form-floating normal">
									<Field
									as="textarea"
									type="text"
									className="form-control"
									name="requirements"
									id="requirements"
									placeholder="Write job description"
									/>
									<label htmlFor="requirements" className="form-label">
									Project description*
									</label>
									<ErrorMessage
									className="error-message"
									name="requirements"
									component="span"
									style={{
										color: "red",
									}}
									/>
								</div>
								</Col>

								<Col lg={7}>
								<div className="sign-nda">
									<a href="#">
									<Image src="/images/home/tick-circle.svg" alt="" /> 100%
									confidential{" "}
									</a>
									<a href="#">
									<Image src="/images/home/tick-circle.svg" alt="" /> We
									sign NDA{" "}
									</a>
								</div>
								</Col>
								<Col lg={5}>
								<div className="budget-btn">
									<button className="btn btn-primary"> Send Now </button>
								</div>
								</Col>
							</Row> */}
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default Banner;
